import { helpers } from 'vuelidate/lib/validators'

export default (greaterThan) =>
  helpers.withParams(
    {type: 'greater', gt: greaterThan},
    (value) => value > greaterThan
  )